import React from "react";

export class Radio extends React.PureComponent {
    render() {
        let myCSS;
        if (this.props.radioVisible) {
            myCSS = { visibility: "visible" };
        }
        else {
            myCSS = { visibility: "hidden" };
        };
        if (!this.props.radioDisabled) {
            return (
                <React.Fragment>
                    <input type="radio" name={this.props.name} onChange={this.props.handleChange} value={this.props.value} id={this.props.id} checked={this.props.checked} style={myCSS} />
                    <label htmlFor={this.props.id}>{this.props.beschriftung}</label>
                </React.Fragment>
            );
        }
        else {
            return (
                <React.Fragment>
                    <input type="radio" name={this.props.name} onChange={this.props.handleChange} value={this.props.value} id={this.props.id} checked={this.props.checked} style={myCSS} disabled />
                    <label htmlFor={this.props.id}>{this.props.beschriftung}</label>
                </React.Fragment>
            );
        };
    };
};